<app-confirm-action-modal
  testId="delete-location-dialog"
  title="Delete Location?"
  message="Are you sure you want to remove this location from your dashboard? This action cannot be undone."
  confirmLabel="Delete"
  confirmButtonClass="delete-btn"
  [mobileSheet]="false"
  (confirm)="onConfirm()"
  (cancel)="onClose()"
></app-confirm-action-modal>
